export const objectIsEmpty = (obj: Record<string, any>): boolean => {
  if (!obj) {
    return true;
  }
  const keys = Object.keys(obj);
  if (keys.length === 0) {
    return true;
  }
  const allKeysUndefined = keys.every((key) => obj[key] === undefined);
  if (allKeysUndefined) {
    return true;
  }
  return false;
};
